"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var drawerWidth = 240;
var headerHeight = 72;
var drawerGap = 0;

var _default = function _default(theme) {
  return {
    root: {
      display: "flex",
      flexDirection: "column",
      width: "95vw",
      margin: "0px"
    },
    drawer: _defineProperty({}, theme.breakpoints.up("sm"), {
      zIndex: "998",
      width: drawerWidth,
      flexShrink: 0
    }),
    filtersButton: _defineProperty({}, theme.breakpoints.up("sm"), {
      display: "none"
    }),
    toolbar: {
      width: "calc(100% - 10px)",
      marginLeft: "10px"
    },
    drawerPaper: _defineProperty({
      width: drawerWidth
    }, theme.breakpoints.up("sm"), {
      top: "calc(".concat(headerHeight, "px - 30px + ").concat(drawerGap, "px)"),
      height: "calc(100vh - ".concat(headerHeight, "px + 30px - ").concat(drawerGap, "px)")
    }),
    filtersList: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignSelf: "center",
      margin: "0px",
      width: "100%"
    },
    categoryListText: _defineProperty({}, theme.breakpoints.up("sm"), {
      flexGrow: 0
    }),
    content: _defineProperty({
      position: "absolute",
      top: headerHeight,
      padding: theme.spacing(1),
      width: "100%"
    }, theme.breakpoints.up("sm"), {
      left: drawerWidth,
      width: "calc(100% - ".concat(drawerWidth, "px)"),
      alignSelf: "flex-end"
    }),
    filterItem: {
      listStyleType: "none"
    },
    entriesList: {
      padding: "0px",
      display: "flex",
      flexWrap: "wrap"
    },
    entry: _defineProperty({
      margin: "10px",
      flexWrap: "wrap",
      listStyleType: "none",
      alignSelf: "stretch",
      width: "90%"
    }, theme.breakpoints.up("lg"), {
      width: "45%"
    }),
    nested: {
      paddingLeft: theme.spacing(4)
    },
    storyCard: {
      height: "1000px"
    }
  };
};

exports["default"] = _default;